import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';

export type StepStatus = 'incomplete' | 'current' | 'complete' | 'error' | 'denied';

export type StepType = 'thinking' | 'search' | 'tool' | 'edit' | 'file' | 'text' | 'done' | 'skill';

@Component({
  selector: 'agent-step-item',
  standalone: true,
  templateUrl: './step.item.component.html',
  styleUrls: ['./step.item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class]': '"step-" + $type()',
    '[class.step-last]': '$isLast()',
  },
})
export class AgentStepItemComponent {

  /** Step type — determines the icon */
  public readonly $type = input<StepType>('tool', { alias: 'type' });

  /** Step status — determines icon variant and color */
  public readonly $status = input<StepStatus>('incomplete', { alias: 'status' });

  /** Whether this is the last step (hides connector) */
  public readonly $isLast = input<boolean>(false, { alias: 'isLast' });

  public readonly $iconClass = computed(() => {


    const status = this.$status();
    const type = this.$type();

    // Error/denied override all types
    if (status === 'error') return 'fa-regular fa-triangle-exclamation';
    if (status === 'denied') return 'fa-regular fa-ban';

    // Spinner for actively running steps
    if (status === 'current') {
      if (type === 'thinking' || type === 'text') return 'fa-regular fa-clock';
      return 'fa-solid fa-spinner fa-spin';
    }

    // Each type keeps its own icon regardless of complete/incomplete.
    // Only 'done' type gets the circle-check.
    switch (type) {
      case 'thinking': return 'fa-regular fa-timer';
      case 'text': return 'fa-regular fa-timer';
      case 'search': return 'fa-regular fa-magnifying-glass';
      case 'tool': return 'fa-regular fa-wrench';
      case 'edit': return 'fa-regular fa-pen-to-square';
      case 'file': return 'fa-regular fa-file-lines';
      case 'done': return 'fa-regular fa-circle-check';
      case 'skill': return 'fa-regular fa-bolt';
      default: return 'fa-regular fa-circle-dot';
    }
  });
}
